import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MessageGenerateComponent, MessageType } from '@/common/message-generate/message-generate.component';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { NgClass } from '@angular/common';
import { SmsGenerateAdapter } from '@/common/message-generate/adapters/sms-generate.adapter';

@Component({
	selector: 'app-sms-generate-dialog',
	standalone: true,
	imports: [MessageGenerateComponent, MatTableModule, MatTooltipModule, NgClass, MatProgressBarModule],
	template: `<app-message-generate
			[itemsIds]="slotListId"
			[type]="MessageType.SMS"
			(closeDialog)="dialogRef.close(true)"
			[previewTemplate]="smsPreviewTpl"
			[adapter]="smsAdapter"
		>
			></app-message-generate
		>

		<ng-template #smsPreviewTpl let-items let-previewLoader="previewLoader">
			<table class="fixed-layout" mat-table [dataSource]="items">
				<ng-container matColumnDef="userData">
					<th mat-header-cell *matHeaderCellDef>Imie i nazwisko</th>
					<td mat-cell *matCellDef="let element">
						{{ element.userData?.firstName }}
						{{ element.userData?.lastName }}
					</td>
				</ng-container>

				<ng-container matColumnDef="city">
					<th mat-header-cell *matHeaderCellDef>Miasto</th>
					<td mat-cell *matCellDef="let element">
						<span
							[matTooltip]="
								element.isStopValid ? '' : 'Coś jest nie tak z tym przystankiem, sprawdź rozkład'
							"
							[ngClass]="{ 'text-danger': !element.isStopValid }"
						>
							{{ element.city }}
						</span>
					</td>
				</ng-container>

				<ng-container matColumnDef="phone">
					<th mat-header-cell *matHeaderCellDef>Tel.</th>
					<td mat-cell *matCellDef="let element">{{ element.phone }}</td>
				</ng-container>

				<ng-container matColumnDef="slotId">
					<th mat-header-cell *matHeaderCellDef>Id</th>
					<td mat-cell *matCellDef="let element">
						{{ element.slotId }}
					</td>
				</ng-container>

				<ng-container matColumnDef="preview">
					<th mat-header-cell *matHeaderCellDef>Wiadomość</th>
					<td mat-cell *matCellDef="let element" matTooltipPosition="right" [matTooltip]="element.message">
						@if (previewLoader) {
							<mat-progress-bar mode="indeterminate"></mat-progress-bar>
						} @else {
							<span class="truncate-message">
								{{ element.message }}
							</span>
						}
					</td>
				</ng-container>

				<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
				<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
			</table>
		</ng-template> `,
	styleUrl: './sms-generate-dialog.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SmsGenerateDialogComponent {
	readonly slotListId = inject<number[]>(MAT_DIALOG_DATA);
	readonly dialogRef = inject(MatDialogRef);
	readonly smsAdapter = inject(SmsGenerateAdapter);

	readonly MessageType = MessageType;

	readonly displayedColumns: string[] = ['userData', 'city', 'phone', 'slotId', 'preview'];
}
